import httpService from '../httpService';
import { APIResponse } from '@/types';
import {
    GetAllProductsResponse,
    //GetProductResponse,
    AddProductsResponse,
    AddProductRequest,
    EditProductRequest,
    EditProductResponse,
    ProductListRequest,
    ProductListResponse,
    RemoveProductsParams,
    RemoveProductsResponse,
    ImportProductsResponse,
    ImportProductsRequest,
    QueueJobStatusResponse,
    ProductDetails,
    ImportFamilyMartTfmCsvResponse,
    ImportLotussCsvResponse,
    ImportTaiwanMobileXlsxResponse,
} from '@/types/pages/storeManagement/product';

const getInitiator = (): string => `webpage|${window.location.href}`;

export function getAllProducts(
    corporationId: number,
    params: ProductListRequest,
    options?: { signal?: AbortSignal },
): APIResponse<ProductListResponse> {
    return httpService.get(`/products/list/${corporationId}`, { params, signal: options?.signal });
}

// export const getProductByBarcode = async (
//     barcode: string,
//     storeId: number,
// ): Promise<GetProductResponse> => {
//     const response = await httpService.get<GetProductResponse>(
//         `/product/${barcode}`,
//         {
//             params: { store_id: storeId, find_by: 'barcode' },
//         },
//     );
//     return response.data;
// };

export const addNewProducts = async (
    storeId: number,
    newProducts: AddProductRequest[],
): Promise<AddProductsResponse> => {
    const response = await httpService.post<AddProductsResponse>('/product', {
        store_id: storeId,
        new_products: newProducts,
        m2c_initiator: getInitiator(),
    });
    return response.data;
};

export const removeProducts = async (params: RemoveProductsParams): APIResponse<RemoveProductsResponse> => {
    const response = await httpService.delete(`/products`, {
        data: {
            ...params,
            m2c_initiator: getInitiator(),
        },
        headers: { 'Content-Type': 'application/json' },
    });
    return response;
};

export const editProducts = async (
    storeId: number,
    editProduct: EditProductRequest[],
): APIResponse<EditProductResponse> => {
    const response = await httpService.put(`/products`, {
        store_id: storeId,
        updated_products: editProduct,
        m2c_initiator: getInitiator(),
    });
    return response;
};

export function fetchProductDetails(storeId: number, barcode: string): APIResponse<ProductDetails> {
    return httpService.get(`/product/${barcode}`, {
        params: { store_id: storeId },
    });
}

export function getExportProducts(cid: number, storeId: number): APIResponse<GetAllProductsResponse> {
    return httpService.get(`/products/list/${cid}`, {
        params: { f_store: storeId, export: 1 },
    });
}

export function importProducts(data: ImportProductsRequest): APIResponse<ImportProductsResponse> {
    return httpService.put('/products/sync', {
        ...data,
        m2c_initiator: getInitiator(),
    });
}

export function handleGetQueueJobStatus(storeId: number, jobId: string): APIResponse<QueueJobStatusResponse> {
    return httpService.post(`/polling-job-status`, {
        store_id: storeId,
        job_id: jobId,
    });
}

export function importFamilyMartTfmCsvAPI(
    data: Blob,
    preprocCode: string,
    filename: string,
): APIResponse<ImportFamilyMartTfmCsvResponse> {
    const additionalHeaders = {
        'M2comm-Key': preprocCode,
        'M2comm-Filename': encodeURIComponent(filename),
        'Content-Type': 'application/octet-stream',
    };
    return httpService.post('/preproc/dispatcher/familymart', data, {
        headers: additionalHeaders,
    });
}

export function importLotussCsvAPI(
    data: Blob,
    preprocCode: string,
    filename: string,
): APIResponse<ImportLotussCsvResponse> {
    const additionalHeaders = {
        'M2comm-Key': preprocCode,
        'M2comm-Filename': encodeURIComponent(filename),
        'Content-Type': 'application/octet-stream',
    };
    return httpService.post('/preproc/dispatcher/lotuss', data, {
        headers: additionalHeaders,
    });
}

/** Only for TWM, the rule of M2comm-key is " preproc_code:store_code ". */
export function importTaiwanMobileXlsxAPI(
    data: Blob,
    preprocCode: string,
    storeCode: string,
    filename: string,
): APIResponse<ImportTaiwanMobileXlsxResponse> {
    const additionalHeaders = {
        'M2comm-Key': `${preprocCode}:${storeCode}`,
        'M2comm-Filename': encodeURIComponent(filename),
        'Content-Type': 'application/octet-stream',
    };
    return httpService.post('/preproc/dispatcher/twm', data, {
        headers: additionalHeaders,
    });
}
